import { callable } from "../firebase.js";

const call = async (name, payload) => (await callable(name)(payload)).data;
export const listPresets = ({ includeInactive } = {}) =>
  call("listPresets", { ...(includeInactive !== undefined ? { includeInactive } : {}) });
export const createPreset = (input) => call("createPreset", input);
export const updatePreset = (input) => call("updatePreset", input);
export const setPresetActive = ({ presetId, active }) => call("setPresetActive", { presetId, active });
export const seedPresets = () => call("seedPresets", {});
